import React from "react";

import {
  Image as ImageComponent,
  Video as VideoComponent,
  VideoProps,
} from "@touchtech/baselayer-ui";

import ProgressSpinner from "@assets/icons/svgr/progress-spinner.svg";

import { PLACEHOLDER_IMAGE_SRC } from "@is/constants";
import { useMedia } from "@is/hooks/media-manager";
import { MediaVariant } from "@is/types";
import { getImageUri, getVideoUri } from "@is/utils";
import { getEnvValue } from "@is/utils/env";

type Props = VideoProps & {
  mediavariant: MediaVariant;
  alt?: string;
  showloadingspinner?: boolean;
};

function Video(props: Props) {
  const { showloadingspinner, mediavariant, ...restProps } = props;

  const { src: videoSrc, isLoading } = useMedia(
    getVideoUri(getEnvValue("VITE_VIDEO_SERVICE_URL"), props.src, mediavariant)
  );

  const { src: posterSrc } = useMedia(
    getImageUri(getEnvValue("VITE_IMAGE_SERVICE_URL"), props.src, mediavariant),
    {
      placeholderSrc: PLACEHOLDER_IMAGE_SRC,
    }
  );

  return videoSrc ? (
    <VideoComponent
      {...restProps}
      key={videoSrc}
      src={videoSrc}
      poster={posterSrc}
    >
      {showloadingspinner && isLoading ? <ProgressSpinner /> : props.children}
    </VideoComponent>
  ) : (
    <ImageComponent layout={props.layout} src={posterSrc}>
      {showloadingspinner && isLoading ? <ProgressSpinner /> : props.children}
    </ImageComponent>
  );
}

export default Video;
